module.exports = __webpack_public_path__ + "img/loghi_0000_iraiser.93c24de1.png";